export interface CompanyLogo {
  name: string;
  logo: string;
  link?: string;
}

export const companyLogos: CompanyLogo[] = [
  {
    name: 'TechNirvana',
    logo: '/Images/technirvana.png',
    link: 'https://technirvana.com.np//'
  },
  {
    name: 'Vaidya Energy',
    logo: '/Images/vaidya.png',
    link: 'https://voith.com.np//'
  },
  {
    name: 'Hajir',
    logo: '/Images/hajirlogo.png',
    link: 'https://hajirapp.com/'
  },
  {
    name: 'SolveeTech',
    logo: '/Images/solvee.png',
    link: 'https://solveetech.com/'
  },
  // Add more company logos as needed, using the /Images/filename.png path
]; 